import { COLORS } from '@cocolocala/ui-components';
import { styled } from 'linaria/react';
import React, { FC } from 'react';
type Props = {
  isValid: boolean;
  message: string;
};
const ValidationCheck: FC<Props> = ({
  isValid,
  message
}) => {
  return <Container>
      {isValid ? <>
          <CheckedSVG />
          <CheckCompletedText>{message}</CheckCompletedText>
        </> : <>
          <NotCheckedSVG />
          <NotCheckCompletedText>{message}</NotCheckCompletedText>
        </>}
    </Container>;
};
export default ValidationCheck;
const NotCheckedSVG = () => <>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.88881 11.5042C6.6153 11.5042 6.3418 11.4017 6.10248 11.1965L3.33325 8.42731L4.87171 6.88885L6.88881 8.90594L11.1281 4.66663L12.6666 6.20509L7.67513 11.1965C7.47 11.4017 7.1965 11.5042 6.88881 11.5042Z" fill="black" fillOpacity="0.15" />
    </svg>
  </>;
const CheckedSVG = () => <>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.88881 11.5042C6.6153 11.5042 6.3418 11.4017 6.10248 11.1965L3.33325 8.42731L4.87171 6.88885L6.88881 8.90594L11.1281 4.66663L12.6666 6.20509L7.67513 11.1965C7.47 11.4017 7.1965 11.5042 6.88881 11.5042Z" fill="#5AC486" />
    </svg>
  </>;
const Container = /*#__PURE__*/styled("p")({
  name: "Container",
  class: "cnyb6n1"
});
const NotCheckCompletedText = /*#__PURE__*/styled("span")({
  name: "NotCheckCompletedText",
  class: "nkxom3p"
});
const CheckCompletedText = /*#__PURE__*/styled("span")({
  name: "CheckCompletedText",
  class: "c1g84xzp"
});

require("./validationCheck.linaria.module.css!=!../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./validationCheck.tsx");